import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var AdyenIssueIA = function AdyenIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bidl+1",
    defaultMessage: [{
      "type": 0,
      "value": "Om problemen met Adyen op te lossen is het het efficiëntst om rechtstreeks contact op te nemen met hun ondersteuningsteam. Hier volgen enkele belangrijke aandachtspunten voordat je contact opneemt met hun ondersteuning:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "V5yO9f",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Voltooi het instellen van je account"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": zorg ervoor dat je Adyen binnen 6 weken hebt ingesteld. Zo niet, dan kan je account tijdelijk worden opgeschort."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rrru2r",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verifieer je rekening:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " zorg ervoor dat Adyen je rekening heeft geverifieerd. Je uitbetalingen worden niet verwerkt totdat je bankrekening is geverifieerd door Adyen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YOwZcP",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verstrek de vereiste gegevens"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": Adyen kan aanvullende gegevens vragen ter verificatie, vooral als je een bepaald bedrag aan omzet hebt bereikt (£ 1.000/ € 1.000/1.000 CHF). Zorg ervoor dat alle gevraagde gegevens zijn verstrekt."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "6dPuyj",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Controleer het type rekening"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": controleer of het type rekening dat je hebt geselecteerd (zakelijk of particulier) overeenkomt met het type dat op je bankafschrift staat. Dit is belangrijk voor de accountverificatie."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};